import { loadStripe } from '@stripe/stripe-js'

import type { TixConfirmPaymentResult } from './types'

type RetrievePaymentIntentOptions = {
  publishableKey: string
  accountId: string
  clientSecret: string
}

/**
 * Load Stripe under the connected account and retrieve a PaymentIntent by client secret.
 * Used on redirect return pages after `confirmPayment` navigates away (Klarna, Afterpay, redirect 3DS).
 */
export async function retrievePaymentIntent(options: RetrievePaymentIntentOptions): Promise<TixConfirmPaymentResult> {
  try {
    const stripe = await loadStripe(options.publishableKey, { stripeAccount: options.accountId })

    if (!stripe) return { error: new Error('loadStripe returned null — the Stripe SDK may be blocked') }

    const result = await stripe.retrievePaymentIntent(options.clientSecret)

    if (result.error) return { stripeError: result.error }

    return { paymentIntent: result.paymentIntent }
  } catch (e) {
    return { error: e instanceof Error ? e : new Error(String(e)) }
  }
}
